import qs from 'qs';

import { unexpectedExceptionNotification } from '@components';
import { getPersonalTasksSelector } from '@selectors/personal-tasks-selectors';
import axios from '@utils/axios';

const prefix = '@PERSONAL_ORDERS';

export const SET_SEARCH = `${prefix}/SET_SEARCH`;
export const SET_CURRENT_PAGE = `${prefix}/SET_CURRENT_PAGE`;

export const SET_IS_GET_PERSONAL_ORDERS_REQUEST_PROCESSING = `${prefix}/SET_IS_GET_PERSONAL_ORDERS_REQUEST_PROCESSING`;
export const SET_GET_PERSONAL_ORDERS_REQUEST_ERROR = `${prefix}/SET_GET_PERSONAL_ORDERS_REQUEST_ERROR`;
export const SET_PERSONAL_ORDERS = `${prefix}/SET_PERSONAL_ORDERS`;

export const setFiltersAction = filters => ({
    type: SET_SEARCH,
    payload: filters,
});

export const setCurrentPageAction = selectedPage => ({
    type: SET_CURRENT_PAGE,
    payload: selectedPage,
});

/*GET PERSONAL ORDER */
export const setIsGetPersonalTasksRequestProcessing = isProcessing => ({
    type: SET_IS_GET_PERSONAL_ORDERS_REQUEST_PROCESSING,
    payload: isProcessing,
});

export const setGetPersonalTaskRequestError = error => ({
    type: SET_GET_PERSONAL_ORDERS_REQUEST_ERROR,
    payload: error,
});

export const setPersonalOrders = personalOrders => ({
    type: SET_PERSONAL_ORDERS,
    payload: personalOrders,
});

export const getPersonalOrder = () => async (dispatch, getState) => {
    dispatch(setIsGetPersonalTasksRequestProcessing(true));
    try {
        const { filters, currentPage } = getPersonalTasksSelector(getState());
        const queryParams = qs.stringify({ ...filters, page: currentPage + 1 });

        const { data } = await axios.get(`/api/orders?${queryParams}`);

        dispatch(setPersonalOrders(data));
    } catch (error) {
        dispatch(setGetPersonalTaskRequestError(error));
        unexpectedExceptionNotification();
    }
    dispatch(setIsGetPersonalTasksRequestProcessing(false));
};
